jQuery(document).ready(function ($) {
    function getCommentEditor() {
        if (typeof tinymce !== 'undefined') {
            return tinymce.get('comment');
        }
        return null;
    }

    function setCommentEditorContent(html) {
        var editor = getCommentEditor();
        if (editor) {
            editor.setContent(html || '');
            return;
        }
        $('#comment').val(html || '');
    }

    function refreshCommentEditor() {
        var $iframe = $('#comment_ifr');
        if ($iframe.length && (!$iframe.height() || $iframe.height() < 80)) {
            $iframe.css('height', '180px');
        }
        var editor = getCommentEditor();
        if (editor) {
            editor.fire('ResizeEditor');
            editor.focus();
        }
    }

    function setCommentParent(parentId) {
        parentId = parseInt(parentId, 10) || 0;
        var $field = $('#comment_parent');
        if (!$field.length && $('#commentform').length) {
            $('#commentform').append('<input type="hidden" name="comment_parent" id="comment_parent" value="0">');
            $field = $('#comment_parent');
        }
        $field.val(parentId);
        $('input[name="comment_parent"]').val(parentId);
    }

    function getStickyHeaderOffset() {
        var $nav = $('#top-navigation');
        return ($nav.outerHeight() || 96) + 16;
    }

    function scrollToFirstForumComment(instant) {
        var $target = $('#forum-comments-list, .forum-thread .comment-list').first();
        if (!$target.length) {
            $target = $('#comments');
        }
        if (!$target.length) {
            return;
        }

        var top = $target.offset().top - getStickyHeaderOffset();
        if (top < 0) {
            top = 0;
        }

        $('html, body').stop(true).animate({
            scrollTop: top
        }, instant ? 0 : 300);
    }

    function shouldScrollToForumComments() {
        var hash = window.location.hash;
        return hash === '#comments' || hash === '#forum-comments-list';
    }

    function getCommentReplyId($el) {
        var id = $el.attr('data-commentid') || $el.closest('[data-commentid]').attr('data-commentid');
        if (!id) {
            var wrapId = $el.closest('.forum-thread-comment-wrap, .general-container[id^="comment-"]').attr('id') || '';
            id = wrapId.replace('comment-', '');
        }
        return parseInt(id, 10) || 0;
    }

    function openForumComposer(options) {
        options = options || {};
        var $thread = $('.forum-thread');
        if (!$thread.length) {
            return;
        }

        $thread.addClass('is-replying');

        var $form = $thread.find('.create_comment_parent');
        var $login = $thread.find('.isnt_user_logged_in');
        var $verify = $thread.find('.verify-email-section');
        var $target = $form.length ? $form : ($login.length ? $login : $verify);

        $form.addClass('is-open');
        $login.addClass('is-open');
        $verify.addClass('is-open');

        setCommentParent(options.parentId);

        if ($form.length) {
            setCommentEditorContent('');
            setTimeout(refreshCommentEditor, 80);
        }

        if ($target.length) {
            $('html, body').animate({
                scrollTop: $target.offset().top - 120
            }, 300);
        }
    }

    function closeForumComposer() {
        var $thread = $('.forum-thread');
        $thread.removeClass('is-replying');
        $thread.find('.create_comment_parent, .isnt_user_logged_in, .verify-email-section').removeClass('is-open');
        setCommentParent(0);
        setCommentEditorContent('');
    }

    if ($('.forum-thread').length) {
        $(document).on('click', '.forum-thread-reply-btn, .forum-thread-open-reply', function (e) {
            e.preventDefault();
            openForumComposer();
        });

        $(document).on('click', '.forum-thread-comment-reply', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            openForumComposer({
                parentId: getCommentReplyId($(this))
            });
        });

        $(document).on('click', '.cancel-forum-reply', function (e) {
            e.preventDefault();
            closeForumComposer();
        });

        if (shouldScrollToForumComments()) {
            scrollToFirstForumComment(true);
            $(window).on('load', function () {
                scrollToFirstForumComment(true);
            });
        }

        $(document).on('click', 'a[href*="#comments"]', function (e) {
            if (!$('.forum-thread').length) {
                return;
            }

            var url;
            try {
                url = new URL(this.href, window.location.origin);
            } catch (err) {
                return;
            }

            if (url.pathname !== window.location.pathname) {
                return;
            }
            if (url.hash !== '#comments' && url.hash !== '#forum-comments-list') {
                return;
            }

            e.preventDefault();
            scrollToFirstForumComment(false);
            if (window.history && window.history.replaceState) {
                window.history.replaceState(null, '', '#comments');
            }
        });

        if ($('.forum-thread .create_comment_parent.is-open, .forum-thread .isnt_user_logged_in.is-open, .forum-thread .verify-email-section.is-open').length) {
            var replyTo = new URLSearchParams(window.location.search).get('replytocom');
            openForumComposer({
                parentId: replyTo || 0
            });
        }
    }

    $(document).on('click', '.edit-comment-button', function (e) { 
        let msg = $(this).closest('.forum-thread-comment-wrap, .forum_post, .general-container').find('.text-msg').html();
        $("#edit_comment_ifr").contents().find("#tinymce").html(msg);
        $('.create_comment_parent').addClass('d-none');
        $(".edit_the_comment_parent").removeClass('d-none');
        location.hash = "";
        location.hash = $('.forum-thread').length ? "#comments" : "#tips-comments";
        $('#comment-id').val($(this).attr('data-id'));
    });
    $(document).on('click', '.cancel-edit-comment', function (e) { 
        $('.edit_the_comment_parent').addClass('d-none');
        $('.create_comment_parent').removeClass('d-none');
        $("#edit_comment_ifr").contents().find("#tinymce").html('');
    });

    function setupForumReplyClamp($content) {
        if (!$content.length || $content.data('clampReady')) {
            return;
        }

        var $button = $content.siblings('.forum-pages-read-more');
        if (!$button.length) {
            return;
        }

        $content.data('clampReady', true);

        function updateClamp() {
            if ($content.hasClass('is-expanded')) {
                return;
            }

            $content.addClass('is-clamped');
            var el = $content.get(0);
            if (!el) {
                return;
            }

            if (el.scrollHeight > el.clientHeight + 2) {
                $button.prop('hidden', false);
            } else {
                $button.prop('hidden', true);
            }
        }

        updateClamp();
        requestAnimationFrame(updateClamp);
        setTimeout(updateClamp, 100);
        $content.find('img').on('load', updateClamp);
    }

    function initForumReplyClamps(scope) {
        $(scope || document).find('.forum-pages-post--reply .forum-pages-post__content').each(function () {
            setupForumReplyClamp($(this));
        });
    }

    initForumReplyClamps();

    $(document).on('click', '.forum-pages-read-more', function (e) {
        e.preventDefault();
        var $button = $(this);
        var $content = $button.siblings('.forum-pages-post__content');
        var expanded = $content.hasClass('is-expanded');

        if (expanded) {
            $content.removeClass('is-expanded').addClass('is-clamped');
            $button.text('Les mer');
        } else {
            $content.removeClass('is-clamped').addClass('is-expanded');
            $button.text('Vis mindre');
        }
    });

    $(document).on('click', '.delete-comment-button', function(e){
        e.preventDefault();
        if (confirm('Are You Sure?')){
            $.ajax({
                method: 'POST',
                url: script_object.ajax_url,
                type: 'JSON',
                data: {
                    action: 'delete_comment_ajax',
                    comment_id: $(this).attr("value"),
                },
                success: function(response) {
                    location.reload();
                },
            })
     }
    })

    $(document).on('click', '.like', function (e) {

        var comment_id = $(this).attr('comment_id');
        var user_id = $(this).attr('user_id');
        var post_id = $(this).attr('post_id');
        var post_author = $(this).attr('post_author');
        var post_type = $(this).attr('post_type');
        if (user_id > 0) {
            $.ajax({
                method: 'POST',
                url: script_object.ajax_url,
                type: 'JSON',
                data: {
                    state: 'like',
                    comment_id: comment_id,
                    user_id: user_id,
                    action: 'image',
                    post_id: post_id,
                    post_author:post_author,
                    post_type: post_type,
                },
                success: function (response) {
                },
            });
            var buttonLike = $(this);
            var buttonUnLike = $(this).closest('.forum_post-message_buttons').find('.dislike');

            var num_likes = buttonLike.closest('.parent_likeButton').find('.num');
            var num_dislikes = buttonUnLike.closest('.parent_dislikeButton').find('.num');
            
            if (buttonLike.attr('state') == 'false' && buttonUnLike.attr('state') == 'false') {
                buttonLike.attr('state', 'true');
                num_likes.html(parseInt(buttonLike.attr('sum')) + parseInt(1))
                buttonLike.attr("sum", parseInt(buttonLike.attr('sum')) + parseInt(1));

            } else if (buttonLike.attr('state') == 'true' && buttonUnLike.attr('state') == 'false') {
                buttonLike.attr('state', 'false')
                if(parseInt(buttonLike.attr('sum')) > 0){
                    num_likes.html(parseInt(buttonLike.attr('sum')) - parseInt(1))
                    buttonLike.attr("sum", parseInt(buttonLike.attr('sum')) - parseInt(1));
                }else{
                    buttonLike.attr("sum", "0");
                    num_likes.html("0")
                }
            }
            else if (buttonLike.attr('state') == 'false' && buttonUnLike.attr('state') == 'true') {
                buttonLike.attr('state', 'true')
                buttonUnLike.attr('state', 'false')

                num_likes.html(parseInt(buttonLike.attr('sum')) + parseInt(1))
                buttonLike.attr("sum", parseInt(buttonLike.attr('sum')) + parseInt(1));
                if(buttonUnLike.attr('sum') - parseInt(1) > 0){
                    num_dislikes.html(parseInt(buttonUnLike.attr('sum')) - parseInt(1))
                    buttonUnLike.attr("sum", parseInt(buttonUnLike.attr('sum')) - parseInt(1));
                }else{
                    buttonUnLike.attr("sum", "0");
                    num_dislikes.html("0")
                }
            } else {
                buttonLike.attr('state', 'true')
                num_likes.html(parseInt(buttonLike.attr('sum')) + parseInt(1))
                buttonLike.attr("sum", parseInt(buttonLike.attr('sum')) + parseInt(1));
            }
            
            if($(this).closest('.notifications').length != 0) {
                $(this).removeClass("d-flex");
                $(this).addClass("d-none");
            }
        }
    });
    
    $(document).on('click', '.load_more_comments', function(e){
        let postID = $('#load_more_comments-post').text();
        let offset = $('#exlude-comments').text();
        let excluded_comments_js = $(".excluded-comments-js").text();
        let offset_array = offset.substring(0, offset.lastIndexOf(','));
        let comment_count = $('#number-of-comments').text();
        let exluds = excluded_comments_js.substring(0, excluded_comments_js.lastIndexOf(','));
        
        if(comment_count){
            $('#load_more_comments').hide();
        }

        $.ajax({
            method: 'POST',
            url: script_object.ajax_url,
            type: 'JSON',
            data: {
                page: '++page',
                action: 'load_more_comments',
                post_id: postID,
                offset_comments: exluds ? exluds : offset_array,
                total: comment_count,
            },
            success: function(response) {
                if (response.indexOf("remove_load_more") > -1) {
                    $('.load_more_comments').hide();
                }
                    $('.comment-list').append(response);
                    initForumReplyClamps('.comment-list');
                
                
            },

        });
    });

    $(document).on('click', '.dislike', function (e) {
        var comment_id = $(this).attr('comment_id');
        var user_id = $(this).attr('user_id');
        var post_id = $(this).attr('post_id');
        var post_author = $(this).attr('post_author');
        if (user_id > 0) {
            $.ajax({
                method: 'POST',
                url: script_object.ajax_url,
                type: 'JSON',
                data: {
                    state: 'unlike',
                    comment_id: comment_id,
                    user_id: user_id,
                    action: 'image',
                    post_id: post_id,
                    post_author: post_author,
                },
                success: function (response) {
                },
            });
            var buttonLike = $(this);
            var buttonUnLike = $(this).closest('.forum_post-message_buttons').find('.like');

            var num_likes = buttonLike.closest('.parent_dislikeButton').find('.num');

            var num_dislikes = buttonUnLike.closest('.parent_likeButton').find('.num');

            if (buttonLike.attr('state') == 'false' && buttonUnLike.attr('state') == 'false') {
                buttonLike.attr('state', 'true');
                num_likes.html(parseInt(buttonLike.attr('sum')) + parseInt(1))
                buttonLike.attr("sum", parseInt(buttonLike.attr('sum')) + parseInt(1));

            } else if (buttonLike.attr('state') == 'true' && buttonUnLike.attr('state') == 'false') {
                buttonLike.attr('state', 'false')
                if(parseInt(buttonLike.attr('sum')) > 0){
                    num_likes.html(parseInt(buttonLike.attr('sum')) - parseInt(1))
                    buttonLike.attr("sum", parseInt(buttonLike.attr('sum')) - parseInt(1));
                }else{
                    buttonLike.attr("sum", "0");
                    num_likes.html("0")
                }
            }
            else if (buttonLike.attr('state') == 'false' && buttonUnLike.attr('state') == 'true') {
                buttonLike.attr('state', 'true')
                buttonUnLike.attr('state', 'false')

                num_likes.html(parseInt(buttonLike.attr('sum')) + parseInt(1))
                buttonLike.attr("sum", parseInt(buttonLike.attr('sum')) + parseInt(1));
                if(buttonUnLike.attr('sum') - parseInt(1) > 0){
                    num_dislikes.html(parseInt(buttonUnLike.attr('sum')) - parseInt(1))
                    buttonUnLike.attr("sum", parseInt(buttonUnLike.attr('sum')) - parseInt(1));
                }else{
                    buttonUnLike.attr("sum", "0");
                    num_dislikes.html("0")
                }
            } else {
                buttonLike.attr('state', 'true')
                num_likes.html(parseInt(buttonLike.attr('sum')) + parseInt(1))
                buttonLike.attr("sum", parseInt(buttonLike.attr('sum')) + parseInt(1));
            }
        }
    });
    
});

